import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    institutions: null,
    institutionToDeactivate: null,
    currentPage: 1,
};
const institutionsSlice = createSlice({
    name: 'institutions',
    initialState,
    reducers: {
        setInstitutions: (state, action) => {
            state.institutions = action.payload;
        },
        setInstitutionToDeactivate: (state, action) => {
            state.institutionToDeactivate = action.payload;
        },
        setInstitutionsCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
    },
    selectors: {
        selectInstitutions: (state) => state.institutions,
        selectInstitutionToDeactivate: (state) => state.institutionToDeactivate,
        selectInstitutionsCurrentPage: (state) => state.currentPage,
    },
});
export const { setInstitutions, setInstitutionToDeactivate, setInstitutionsCurrentPage } = institutionsSlice.actions;
export const { selectInstitutions, selectInstitutionToDeactivate, selectInstitutionsCurrentPage } = institutionsSlice.selectors;
export default institutionsSlice.reducer;
